import {useCallback, useEffect, useRef} from 'react'
import {Map} from './MaptilerWrapper'
import StateTilesLayer from './Layers/StateTilesLayer'
import ChartBlankError from '../../../common/ChartBlankError'
import {getMapAccessKey} from './helpers'
import PropTypes from 'prop-types'
import {useTheme} from '@emotion/react'
import {Overlay, ChartBlankErrorWrapper, RootContainer} from './Styles'

const defaultMapLongitude = -95.7
const defaultMapLatitude = 42
const defaultZoomLevel = 3
const stateTilesetSourceLayer = 'states'

const DashboardNoData = ({width, height, onMapReady}) => {
  const mapRef = useRef(null) // Create a ref to store the map instance
  const map = mapRef.current // Get the current map instance
  const theme = useTheme()
  const mapAccessToken = getMapAccessKey()

  useEffect(() => {
    if (map) {
      map.resize()
    }
  }, [width, height, map])

  const disableGestures = (m) => {
    m?.scrollZoom?.disable?.()
    m?.boxZoom?.disable?.()
    m?.dragPan?.disable?.()
    m?.keyboard?.disable?.()
    m?.doubleClickZoom?.disable?.()
    m?.touchZoomRotate?.disable?.()
    m?.touchPitch?.disable?.()
  }

  const onload = useCallback(() => {
    const currentMap = mapRef.current
    if (!currentMap) return
    currentMap.setPaintProperty?.('State labels', 'text-color', theme.palette.hpAccentBlack)
    currentMap.setLayoutProperty('City labels', 'visibility', 'none')
    disableGestures(currentMap)
    onMapReady?.(currentMap)
  }, [theme.palette.hpAccentBlack, onMapReady])

  return (
    <RootContainer data-testid='dashboard-no-data-root'>
      {/* Top-of-map Chart Blank error banner */}
      <ChartBlankErrorWrapper>
        <ChartBlankError chart={'PopulationDensity'} boxheight={height} />
      </ChartBlankErrorWrapper>
      <Map
        ref={mapRef}
        apiKey={mapAccessToken}
        center={[defaultMapLongitude, defaultMapLatitude]}
        zoom={defaultZoomLevel}
        minZoom={defaultZoomLevel}
        navigationControl={false}
        containerStyle={{
          width: width || '100%',
          height: '100%',
          borderRadius: 8
        }}
        style={`https://api.maptiler.com/maps/0195cc95-c491-73db-a7f6-409d6087449a/style.json`}
        geolocateControl={false}
        id='mapElement'
        onLoad={onload}
      >
        <StateTilesLayer
          loadingAggregations={false}
          populationAggregationData={[]}
          selectedFips={[]}
          boundary={'state'}
          stateTilesetSourceLayer={stateTilesetSourceLayer}
          visibility={'visible'}
          stateFipsToPersona={{}}
          personasToggle={false}
        />
      </Map>
      {/* Grey overlay to visually desaturate the basemap */}
      <Overlay data-testid='dashboard-no-data-overlay' />
    </RootContainer>
  )
}

DashboardNoData.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onMapReady: PropTypes.func
}

export default DashboardNoData
